import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/site/motion";
import { screen } from "@/data/screens";

const Tile = ({ id, span, dark = false, img = false, delay = 0 }) => {
  const s = screen(id);
  return (
    <Reveal delay={delay} className={`${span} h-full`}>
      <Link
        to="/features"
        className={`group flex h-full flex-col justify-between border p-6 transition-colors duration-300 sm:p-8 ${dark ? "border-navy bg-navy text-white hover:bg-[#0d1d45]" : "border-slate-200 bg-white hover:border-[#c5a059]"}`}
        data-testid={`bento-tile-${id}`}
      >
        <div>
          <div className="flex items-start justify-between gap-4">
            <p className={dark ? "eyebrow-light" : "eyebrow"}>{s.label}</p>
            <ArrowUpRight className={`h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 ${dark ? "text-[#d9bd85]" : "text-navy"}`} />
          </div>
          <h3 className={`mt-4 font-display text-2xl font-semibold leading-tight sm:text-3xl ${dark ? "text-white" : "text-navy"}`}>{s.title}</h3>
          <p className={`mt-3 max-w-md text-sm leading-relaxed ${dark ? "text-slate-300" : "text-slate-600"}`}>{s.body}</p>
        </div>
        {img && (
          <div className="mt-8 aspect-[16/9] overflow-hidden border border-slate-200">
            <img src={s.img} alt={`Grace Treasury: ${s.title}`} loading="lazy" className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]" />
          </div>
        )}
      </Link>
    </Reveal>
  );
};

export const Bento = () => (
  <section className="bg-parchment py-20 sm:py-28 lg:py-32" data-testid="bento-section">
    <div className="container-x">
      <Reveal className="grid gap-6 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <p className="eyebrow">Capabilities</p>
          <h2 className="h2 mt-4">Built around how church money actually moves.</h2>
        </div>
        <p className="self-end text-base leading-relaxed text-slate-600 lg:col-span-5 lg:col-start-8">
          Gifts arrive for specific purposes, funds sit inside other funds, and the board wants a clear report every month. Grace Treasury is shaped around each of those facts.
        </p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-12 lg:gap-8">
        <Tile id="funds" span="md:col-span-7" img />
        <Tile id="split" span="md:col-span-5" img delay={0.08} />
        <Tile id="reconciliation" span="md:col-span-5" />
        <Tile id="report" span="md:col-span-7" dark delay={0.08} />
        <Tile id="backup" span="md:col-span-4" />
        <Tile id="import" span="md:col-span-4" delay={0.06} />
        <Tile id="fund-activity" span="md:col-span-4" delay={0.12} />
      </div>
    </div>
  </section>
);
